// extracted by mini-css-extract-plugin
export default {"content":"Content_content__V9Y7M","contentInner":"Content_contentInner__A+XLo"};